import React from 'react';

import { Form } from 'antd';
import { InputNumber } from 'antd/lib';
import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { getOrdinalSuffix } from 'components/View/utils';
import { getAreaUnitLabel } from 'utils/helpers/units';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .delete-row-icon {
    display: none;
  }

  &:hover {
    .delete-row-icon {
      display: block;
    }
  }
`;

const InputItemsContainer = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 8px;
`;

const StyledButton = styled.div`
  height: 16px;
  width: 16px;
  cursor: pointer;
`;

const StyledFormItem = styled(Form.Item)`
  &.ant-form-item-has-error {
    .ant-input-number-affix-wrapper {
      border-color: var(--error-red);
    }
  }
`;

const UnitSuffix = styled.span`
  color: var(--text-secondary);
`;

const StyledInputNumber = styled(InputNumber)`
  width: 120px;
`;

const RangeSeparator = styled.div`
  font-size: 12px;
`;

type Props = {
  index: number;
  name: number;
  removeCategory: () => void;
};

const WidgetGroupingCategory = ({ index, name, removeCategory }: Props) => {
  const { community } = useCommunityViewContext();
  const areaUnitLabel = getAreaUnitLabel(community);

  return (
    <Container>
      <div>{getOrdinalSuffix(index + 1)} group</div>
      <InputItemsContainer>
        <StyledFormItem
          name={[name, 'range_start']}
          rules={[
            { required: true, message: 'Missing field' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (index === 0) {
                  return Promise.resolve();
                }
                const prevRangeEnd = getFieldValue(['categories', index - 1, 'range_end']);
                if (value > prevRangeEnd) {
                  return Promise.resolve();
                }
                return Promise.reject();
              },
            }),
          ]}
        >
          <StyledInputNumber type="number" min={0} suffix={<UnitSuffix>{areaUnitLabel}</UnitSuffix>} />
        </StyledFormItem>
        <RangeSeparator>to</RangeSeparator>
        <StyledFormItem
          name={[name, 'range_end']}
          rules={[
            { required: true, message: 'Missing field' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const startValue = getFieldValue(['categories', index, 'range_start']);
                if (value > startValue) {
                  return Promise.resolve();
                }
                return Promise.reject();
              },
            }),
          ]}
        >
          <StyledInputNumber type="number" min={0} suffix={<UnitSuffix>{areaUnitLabel}</UnitSuffix>} />
        </StyledFormItem>
        <StyledButton onClick={removeCategory}>
          <img className="delete-row-icon" src="/icons/close.svg" height={16} width={16} />
        </StyledButton>
      </InputItemsContainer>
    </Container>
  );
};

export default WidgetGroupingCategory;
